import { useTenant } from "../../../contexts/TenantContext";
import { findProvider, readProviderChoice } from "../providerChoice";

/**
 * The guest's choice of provider, as the booking funnel reads it. A tenant with one provider has
 * nothing to choose: its requests name nobody, as before providers, and `hasChoice` is true.
 */
const useProviderChoice = () => {
  const { providers, hasSeveralProviders } = useTenant();
  const choice = hasSeveralProviders ? readProviderChoice(providers) : null;

  return {
    hasChoice: !hasSeveralProviders || !!choice,
    isAnyone: choice?.providerId === null,
    // What the requests send: the chosen provider, or nothing for „Bárki” and a tenant with one.
    providerId: choice?.providerId ?? undefined,
    chosenProvider: choice?.providerId != null ? findProvider(providers, choice.providerId) : undefined,
  };
};

export default useProviderChoice;
